import { onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';

// The query needs to be wrapped by useMemo to avoid unnecessary re-renders
export default function useRealtimeDocs({ query = null, transformData = null }) {
  const [data, setData] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!query) {
      setData([]);
      setStatus('Not a valid query');
      return undefined;
    }
    const unsubscribe = onSnapshot(query, (snapshot) => {
      const dataArr = snapshot.docs.map((doc) => {
        const docData = { id: doc.id, ...doc.data() };
        if (typeof transformData === 'function') {
          try {
            return transformData(doc);
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error transforming data for doc:', doc.id, error);
            return docData;
          }
        }
        return docData;
      });
      setData(dataArr);
      setStatus('success');
    }, () => {
      setData([]);
      setStatus('error');
    });
    return () => {
      unsubscribe();
      setData([]);
      setStatus('loading');
    };
  }, [query, transformData]);

  return { data, status };
}
